//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface UserDto {
    id?: string;
    veracityId?: string;
    name?: string | undefined;
    email?: string | undefined;
    subscription?: SubscriptionLevel;
    unshacledSubscription?: SubscriptionLevel | undefined;
    unshacledTrialCheckTimestamp?: Date | undefined;
    wasPaidSubscriber?: boolean;
    roles?: RoleDto[] | undefined;
    testSessions?: TestSessionDto[] | undefined;
}

export enum SubscriptionLevel {
    None = 0,
    Unpaid = 1,
    Trial = 2,
    Basic = 3,
    Incremental = 4,
    Advanced = 5,
    UnshacledTrial = 6,
    UnshacledGeneration = 7,
    UnshacledValidation = 8,
    UnshacledFull = 9,
}

export interface RoleDto {
    id?: string;
    name?: string | undefined;
}

export interface TestSessionDto {
    conformityLevel?: ConformityLevel;
    conformityLevelId?: string | undefined;
    createdAt?: Date;
    declarationOfConformity?: DeclarationOfConformityDto | undefined;
    declarationOfConformityId?: string | undefined;
    id?: string;
    name?: string | undefined;
    standard?: TestStandardDto | undefined;
    standardId?: string;
    status?: TestSessionStatusDto | undefined;
    statusId?: string;
    testCaseCount?: number;
    testSessionType?: TestSessionTypeDto | undefined;
    testSessionTypeId?: string;
    reviewedAt?: Date | undefined;
    reviewedById?: string | undefined;
    verifiedAt?: Date | undefined;
    verifiedById?: string | undefined;
}

export enum ConformityLevel {
    None = 0,
    Bronze = 1,
    Silver = 2,
    Gold = 3,
}

export interface DeclarationOfConformityDto {
    id?: string;
    name?: string | undefined;
    title?: string | undefined;
    titleFunction?: string | undefined;
    company?: string | undefined;
    country?: string | undefined;
    address?: string | undefined;
    corporateNumber?: string | undefined;
    applicationName?: string | undefined;
    version?: string | undefined;
    agree?: boolean;
}

export interface TestStandardDto {
    id?: string;
    order?: number;
    name?: string | undefined;
    version?: string | undefined;
    isDefault?: boolean;
    isActive?: boolean;
}

export interface TestSessionStatusDto {
    id?: string;
    name?: string | undefined;
    short?: string | undefined;
    order?: number;
    isDefault?: boolean;
}

export interface TestSessionTypeDto {
    id?: string;
    order?: number;
    name?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    declarationFormRequired?: boolean;
    executionApprovalRequired?: boolean;
}

export interface ToggleRoleRequest {
    userId?: string;
    roleId?: string;
}

export interface SetSubscriptionRequest {
    veracityId?: string;
    subscription?: SubscriptionLevel;
}

export interface ReqResInfoVM {
    count?: number;
    sessions?: SessionDto[];
}

export interface SessionDto {
    id?: string;
    name?: string;
    createdAt?: Date;
    executions?: ValimateExecutionDto[];
}

export interface ValimateExecutionDto {
    id?: string;
    sessionId?: string;
    configurationName?: string | undefined;
    testCaseName?: string;
    request?: ValimateRequestDto;
    response?: ValimateResponseDto;
    callbackPayload?: ValimatePayloadDto;
    status?: ValimateExecutionStatus;
    wasRerun?: boolean;
}

export interface ValimateRequestDto {
    id?: string;
    url?: string;
    body?: string;
    valimateRequestType?: ValimateRequestType;
    createdAt?: Date;
}

export enum ValimateRequestType {
    ValidateTestCase = 0,
    StatusRequest = 1,
}

export interface ValimateResponseDto {
    id?: string;
    httpStatusStatusCode?: number;
    body?: string;
}

export interface ValimatePayloadDto {
    id?: string;
    result?: string;
    createdAt?: Date;
    body?: string;
    exception?: string;
}

export enum ValimateExecutionStatus {
    Queued = 0,
    Running = 1,
    Passed = 2,
    Failed = 3,
    Inconclusive = 4,
    Cancelled = 5,
}

export interface TestCase {
    id?: string;
    order?: number;
    name?: string | undefined;
    version?: string | undefined;
    allowInternalEvaluation?: boolean;
    identifier?: string | undefined;
    purpose?: string | undefined;
    requirements?: string | undefined;
    environment?: string | undefined;
    testType?: string | undefined;
    standardId?: string;
    standard?: TestStandard | undefined;
    testSteps?: TestStep[] | undefined;
    testSessions?: TestSession[] | undefined;
    testConfigurations?: TestConfiguration[] | undefined;
}

export interface TestStandard {
    id?: string;
    order?: number;
    name?: string | undefined;
    version?: string | undefined;
    isActive?: boolean;
    isDefault?: boolean;
    testCases?: TestCase[] | undefined;
    functions?: TestCaseFunction[] | undefined;
    profiles?: TestCaseProfile[] | undefined;
    sessions?: TestSession[] | undefined;
    testConfigurations?: TestConfiguration[] | undefined;
}

export interface TestCaseFunction {
    id?: string;
    order?: number;
    name?: string | undefined;
    isReadonly?: boolean;
    standardId?: string;
    standard?: TestStandard | undefined;
}

export interface TestCaseProfile {
    id?: string;
    order?: number;
    name?: string | undefined;
    short?: string | undefined;
    importExportLevelsInternal?: string | undefined;
    importExportLevels?: ImportExportLevel[] | undefined;
    standardId?: string;
    standard?: TestStandard | undefined;
}

export enum ImportExportLevel {
    None = 0,
    Individual = 1,
    Inclusive = 2,
    Difference = 3,
}

export interface TestSession {
    id?: string;
    name?: string | undefined;
    statusId?: string;
    status?: TestSessionStatus | undefined;
    testSessionTypeId?: string;
    testSessionType?: TestSessionType | undefined;
    standardId?: string;
    standard?: TestStandard | undefined;
    declarationOfConformityId?: string | undefined;
    declarationOfConformity?: DeclarationOfConformity | undefined;
    testCases?: TestCase[] | undefined;
    profileSelections?: ProfileSelection[] | undefined;
    functionSelections?: FunctionSelection[] | undefined;
    testFiles?: TestFile[] | undefined;
    testSessionStatusHistory?: TestSessionStatusHistory[] | undefined;
    comments?: TestSessionComment[] | undefined;
    valimateExecutions?: ValimateExecution[] | undefined;
    unshacledExecutions?: UnshacledExecution[] | undefined;
    reviewedAt?: Date | undefined;
    reviewedById?: string | undefined;
    verifiedAt?: Date | undefined;
    verifiedById?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
    createdById?: string;
    createdBy?: User | undefined;
    isActive?: boolean;
}

export interface TestSessionStatus {
    id?: string;
    name?: string | undefined;
    short?: string | undefined;
    order?: number;
    isDefault?: boolean;
    testSessions?: TestSession[] | undefined;
}

export interface TestSessionType {
    id?: string;
    order?: number;
    name?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    declarationFormRequired?: boolean;
    executionApprovalRequired?: boolean;
    testSessions?: TestSession[] | undefined;
}

export interface DeclarationOfConformity {
    id?: string;
    name?: string | undefined;
    title?: string | undefined;
    titleFunction?: string | undefined;
    company?: string | undefined;
    country?: string | undefined;
    address?: string | undefined;
    corporateNumber?: string | undefined;
    applicationName?: string | undefined;
    version?: string | undefined;
    agree?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
    testSession?: TestSession | undefined;
}

export interface ProfileSelection {
    id?: string;
    profileId?: string;
    profile?: TestCaseProfile | undefined;
    testSessionId?: string | undefined;
    testSession?: TestSession | undefined;
    individualImportOption?: ImportExportOption;
    individualExportOption?: ImportExportOption;
    inclusiveImportOption?: ImportExportOption;
    inclusiveExportOption?: ImportExportOption;
    differenceImportOption?: ImportExportOption;
    differenceExportOption?: ImportExportOption;
}

export enum ImportExportOption {
    No = 0,
    Yes = 1,
}

export interface FunctionSelection {
    id?: string;
    functionId?: string;
    function?: TestCaseFunction | undefined;
    testSessionId?: string | undefined;
    testSession?: TestSession | undefined;
    conformity?: ConformityLevel;
}

export interface TestFile {
    id?: string;
    name?: string | undefined;
    internalEvaluation?: boolean;
    testStepId?: string;
    testStep?: TestStep | undefined;
    testDatasetId?: string;
    testDataset?: TestDataset | undefined;
    testConfigurationId?: string | undefined;
    testConfiguration?: TestConfiguration | undefined;
    contentFileNamesInternal?: string | undefined;
    contentFileNames?: string[] | undefined;
    testSessionId?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface TestStep {
    id?: string;
    no?: number;
    description?: string | undefined;
    assessmentCriteria?: string | undefined;
    requiresValidation?: boolean;
    testCaseId?: string;
    testCase?: TestCase | undefined;
    datasets?: TestDataset[] | undefined;
    testFiles?: TestFile[] | undefined;
}

export interface TestDataset {
    id?: string;
    datatype?: Datatype;
    datatypeId?: number;
    description?: string | undefined;
    testFiles?: TestFile[] | undefined;
    validationSteps?: ValidationStep[] | undefined;
}

export enum Datatype {
    Model = 0,
    Other = 1,
}

export interface ValidationStep {
    id?: string;
    order?: number;
    validationType?: ValidationType;
    args?: string[] | undefined;
}

export enum ValidationType {
    Basic = 0,
    Diff = 1,
    Prep = 2,
    Shacl = 3,
    CompareCount = 4,
    CompareData = 5,
    CompareSolution = 6,
    ShaclRef = 7,
    ShaclDiff = 8,
}

export interface TestConfiguration {
    id?: string;
    name?: string | undefined;
    filename?: string | undefined;
    dependency?: TestConfiguration | undefined;
    dependencyId?: string | undefined;
    testCases?: TestCase[] | undefined;
    testStandards?: TestStandard[] | undefined;
    testFiles?: TestFile[] | undefined;
}

export interface TestSessionStatusHistory {
    id?: string;
    previousStatusId?: string;
    previousStatus?: TestSessionStatus | undefined;
    newStatusId?: string;
    newStatus?: TestSessionStatus | undefined;
    sessionId?: string;
    session?: TestSession | undefined;
    changedAt?: Date;
    changedById?: string | undefined;
    changedBy?: User | undefined;
}

export interface AuditableEntity {
    created?: Date;
    createdBy?: string | undefined;
    lastModified?: Date | undefined;
    lastModifiedBy?: string | undefined;
}

export interface User extends AuditableEntity {
    id?: string;
    veracityId?: string;
    subscription?: SubscriptionLevel;
    unshacledSubscription?: SubscriptionLevel | undefined;
    wasPaidSubscriber?: boolean;
    subscriptionCheckTimestamp?: Date;
    trialCheckTimestamp?: Date | undefined;
    unshacledTrialCheckTimestamp?: Date | undefined;
    roles?: Role[] | undefined;
    testSessions?: TestSession[] | undefined;
}

export interface Role {
    id?: string;
    name?: string | undefined;
    users?: User[] | undefined;
}

export interface TestSessionComment {
    id?: string;
    message?: string | undefined;
    testSessionId?: string;
    session?: TestSession | undefined;
    createdById?: string;
    createdBy?: User | undefined;
    originStatus?: TestSessionStatus | undefined;
    originStatusId?: string | undefined;
    destinationStatus?: TestSessionStatus | undefined;
    destinationStatusId?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface ValimateExecution {
    id?: string;
    sessionId?: string;
    session?: TestSession | undefined;
    configurationId?: string | undefined;
    configuration?: TestConfiguration | undefined;
    testCaseId?: string;
    testCase?: TestCase | undefined;
    requestId?: string | undefined;
    request?: ValimateRequest | undefined;
    responseId?: string | undefined;
    response?: ValimateResponse | undefined;
    callbackPayloadId?: string | undefined;
    callbackPayload?: ValimateCallbackPayload | undefined;
    status?: ValimateExecutionStatus;
    wasRerun?: boolean;
}

export interface ValimateRequest {
    id?: string;
    runId?: string;
    sessionId?: string;
    url?: string | undefined;
    body?: string | undefined;
    response?: ValimateResponse | undefined;
    callback?: ValimateCallbackPayload | undefined;
    valimateRequestType?: ValimateRequestType;
    createdAt?: Date;
    createdById?: string;
    createdBy?: User | undefined;
}

export interface ValimateResponse {
    id?: string;
    requestId?: string;
    request?: ValimateRequest | undefined;
    httpStatusStatusCode?: number;
    body?: string | undefined;
}

export interface ValimateCallbackPayload {
    id?: string;
    requestId?: string | undefined;
    request?: ValimateRequest | undefined;
    tucId?: string | undefined;
    result?: string | undefined;
    createdAt?: Date;
    body?: string | undefined;
    exception?: string | undefined;
    domainEvents?: DomainEvent[] | undefined;
}

export interface DomainEvent {
    isPublished?: boolean;
    dateOccurred?: Date;
}

export interface UnshacledExecution {
    id?: string;
    sessionId?: string;
    session?: TestSession | undefined;
    sessionIdentifier?: string | undefined;
    processingMode?: string | undefined;
    status?: number;
    wasRerun?: boolean;
    jobId?: string | undefined;
    requestUrl?: string | undefined;
    requestPayload?: string | undefined;
    responsePayload?: string | undefined;
    httpStatusCode?: number | undefined;
    errorMessage?: string | undefined;
    validationOutcome?: ValidationOutcome | undefined;
    createdAt?: Date;
    completedAt?: Date | undefined;
    createdById?: string;
    createdBy?: User | undefined;
}

export enum ValidationOutcome {
    Success = 0,
    Warning = 1,
    Failed = 2,
}

export interface UpdateModelRequest {
    testCases?: TestCase[] | undefined;
}

export interface MaintenanceModeOptions {
    isEnabled?: boolean;
}

export interface TestConfigurationDto {
    id?: string;
    name?: string | undefined;
    isDefault?: boolean;
}

export interface InitVM {
    user?: CurrentUser | undefined;
    appVersion?: string | undefined;
    maintenanceMode?: MaintenanceModeOptions | undefined;
}

export interface CurrentUser {
    id?: string;
    veracityId?: string;
    name?: string | undefined;
    email?: string | undefined;
    subscription?: SubscriptionLevel;
    unshacledSubscription?: SubscriptionLevel | undefined;
    unshacledTrialCheckTimestamp?: Date | undefined;
    wasPaidSubscriber?: boolean;
    roles?: string[] | undefined;
}

export interface UpdateStep1Request {
    sessionId?: string;
    sessionName?: string | undefined;
    testSessionTypeId?: string;
    declarationOfConformity?: DeclarationOfConformityDto | undefined;
}

export interface StandardDto {
    id?: string;
    order?: number;
    name?: string | undefined;
    isActive?: boolean;
}

export interface StandardVM {
    standard?: StandardDto | undefined;
    testCases?: TestCaseDto[] | undefined;
    functions?: TestCaseFunctionDto[] | undefined;
    profiles?: TestCaseProfileDto[] | undefined;
}

export interface TestCaseDto {
    id?: string;
    order?: number;
    name?: string | undefined;
    version?: string | undefined;
    allowInternalEvaluation?: boolean;
    askForInternalEvaluation?: boolean;
    internalEvaluation?: boolean;
    identifier?: string | undefined;
    purpose?: string | undefined;
    requirements?: string | undefined;
    environment?: string | undefined;
    testType?: string | undefined;
    selected?: boolean;
    testSteps?: TestStepDto[] | undefined;
    standardId?: string;
    testConfigurations?: TestConfigurationDto[] | undefined;
}

export interface TestStepDto {
    id?: string;
    no?: number;
    description?: string | undefined;
    assessmentCriteria?: string | undefined;
    requiresValidation?: boolean;
    testCaseId?: string;
    datasets?: TestDatasetDto[] | undefined;
    testFiles?: TestFileDto[] | undefined;
}

export interface TestDatasetDto {
    id?: string;
    datatype?: Datatype;
    description?: string | undefined;
}

export interface TestFileDto {
    id?: string;
    name?: string | undefined;
    internalEvaluation?: boolean;
    testStepId?: string;
    testStep?: TestStepDto | undefined;
    testDatasetId?: string;
    testDatasetIndex?: number | undefined;
    testConfigurationId?: string | undefined;
    testConfiguration?: TestConfigurationDto | undefined;
    testSessionId?: string;
    contentFileNames?: string[] | undefined;
    tetsCaseName?: string | undefined;
    testCaseIdentifier?: string | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface TestCaseFunctionDto {
    id?: string;
    order?: number;
    name?: string | undefined;
    isReadonly?: boolean;
    conformityOption?: ConformityLevel;
    minImport?: ConformityLevel;
    minExport?: ConformityLevel;
    allowedConformityLevels?: ConformityLevel[] | undefined;
    profileDependencies?: FunctionProfileDependencyDto[] | undefined;
    functionDependencies?: FunctionFunctionDependencyDto[] | undefined;
    unmetImportProfileDependencies?: FunctionProfileDependencyDto[] | undefined;
    unmetExportProfileDependencies?: FunctionProfileDependencyDto[] | undefined;
    unmetFunctionDependencies?: FunctionFunctionDependencyDto[] | undefined;
    standardId?: string;
}

export interface FunctionProfileDependencyDto {
    profileId?: string;
    conformityLevel?: ConformityLevel;
}

export interface FunctionFunctionDependencyDto {
    functionId?: string;
    conformityLevel?: ConformityLevel;
}

export interface TestCaseProfileDto {
    id?: string;
    order?: number;
    name?: string | undefined;
    short?: string | undefined;
    importSelections?: ProfileSelectionsDto | undefined;
    exportSelections?: ProfileSelectionsDto | undefined;
    profileDependencies?: string[] | undefined;
    unmetProfileDependencies?: string[] | undefined;
    importExportLevels?: ImportExportLevel[] | undefined;
    standardId?: string;
}

export interface ProfileSelectionsDto {
    individualOption?: ProfileSelectionOptionDto | undefined;
    inclusiveOption?: ProfileSelectionOptionDto | undefined;
    differenceOption?: ProfileSelectionOptionDto | undefined;
}

export interface ProfileSelectionOptionDto {
    selection?: ImportExportOption;
    unmetDependencies?: string[] | undefined;
}

export interface DeleteFilesRequest {
    files?: TestFileDto[] | undefined;
}

export interface DowloadExecutionStepFilesRequest {
    testSessionId?: string;
    testStepId?: string;
    testConfigurationId?: string | undefined;
}

export interface Step2VM {
    selectedFunctionOptions?: FunctionOptionSelection[] | undefined;
    selectedProfileOptions?: ProfileOptionSelection[] | undefined;
    selectedTestCases?: TestCaseDto[] | undefined;
}

export interface FunctionOptionSelection {
    functionId?: string;
    functionName?: string | undefined;
    option?: ConformityLevel;
}

export interface ProfileOptionSelection {
    profileId?: string;
    profileName?: string | undefined;
    individualImportOption?: ImportExportOption;
    individualExportOption?: ImportExportOption;
    inclusiveImportOption?: ImportExportOption;
    inclusiveExportOption?: ImportExportOption;
    differenceImportOption?: ImportExportOption;
    differenceExportOption?: ImportExportOption;
}

export interface GetRequiredTUCsRequest {
    selectedFunctionOptions?: FunctionOptionSelection[] | undefined;
    selectedProfileOptions?: ProfileOptionSelection[] | undefined;
}

export interface SaveStep2SelectionsRequest {
    sessionId?: string;
    selectedFunctionOptions?: FunctionOptionSelection[] | undefined;
    selectedProfileOptions?: ProfileOptionSelection[] | undefined;
}

export interface TestSessionsListVM {
    testSessions?: TestSessionDto[] | undefined;
    testSessionStatuses?: TestSessionStatusDto[] | undefined;
}

export interface TestSessionVM {
    testSession?: TestSessionDto | undefined;
    testSessionTypes?: TestSessionTypeDto[] | undefined;
    testStandards?: TestStandardDto[] | undefined;
}

export interface SessionSummaryVM {
    choices?: Step2VM | undefined;
    session?: TestSessionDto | undefined;
    user?: UserDto | undefined;
    results?: ValimateTestCaseResultDto[] | undefined;
    history?: TestSessionStatusHistoryDto[] | undefined;
    comments?: TestSessionCommentDto[] | undefined;
    hasFilesToDownload?: boolean;
}

export interface ValimateTestCaseResultDto {
    testCase?: TestCaseDto | undefined;
    testConfigurations?: ValimateConfigurationResultDto[] | undefined;
}

export interface ValimateConfigurationResultDto {
    testConfiguration?: TestConfigurationDto | undefined;
    execution?: ValimateExecutionDto2 | undefined;
}

export interface ValimateExecutionDto2 {
    id?: string;
    configuration?: TestConfigurationDto | undefined;
    testCase?: TestCaseDto | undefined;
    callback?: ValimateCallbackDto | undefined;
    status?: ValimateExecutionStatus;
}

export interface ValimateCallbackDto {
    runId?: string;
    result?: string | undefined;
    errorDescription?: string | undefined;
    steps?: ValimateStep[] | undefined;
}

export interface ValimateStep {
    stepId?: string;
    result?: string | undefined;
    runtime?: number;
    constraints?: ValimateConstraint[] | undefined;
}

export interface ValimateConstraint {
    severity?: string | undefined;
    shaclUri?: string | undefined;
    name?: string | undefined;
    message?: string | undefined;
    modelIndex?: string | undefined;
    valStepIndex?: string | undefined;
    count?: number;
}

export interface TestSessionStatusHistoryDto {
    id?: string;
    previousStatusId?: string;
    previousStatus?: TestSessionStatusDto | undefined;
    newStatusId?: string;
    newStatus?: TestSessionStatusDto | undefined;
    sessionId?: string;
    session?: TestSessionDto | undefined;
    changedAt?: Date;
    changedById?: string | undefined;
    changedBy?: UserDto | undefined;
}

export interface TestSessionCommentDto {
    id?: string;
    message?: string | undefined;
    testSessionId?: string;
    createdById?: string;
    originStatus?: TestSessionStatusDto | undefined;
    originStatusId?: string | undefined;
    destinationStatus?: TestSessionStatusDto | undefined;
    destinationStatusId?: string | undefined;
    createdBy?: UserDto | undefined;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface SessionStatusChangeRequestRequest {
    sessionId?: string;
    statusShortName?: string | undefined;
    message?: string | undefined;
}

export interface CreateCustomProfileSessionRequest {
    name?: string;
}

export interface ValimateRequestDto2 {
    runId?: string;
    sessionId?: string;
    outFolder?: string | undefined;
    outFormats?: string[] | undefined;
    resultCallbackUrl?: string | undefined;
    testSteps?: ValimateRequestTestStepDto[] | undefined;
}

export interface ValimateRequestTestStepDto {
    id?: string;
    config?: ValimateRequestTestStepConfigDto | undefined;
    modelValidationSteps?: ValimateRequestModelValidationStepDto[] | undefined;
}

export interface ValimateRequestTestStepConfigDto {
    cimVersion?: string | undefined;
    mappingType?: string | undefined;
    mappingData?: string | undefined;
    interference?: boolean;
    interferenceFiles?: string[] | undefined;
    cpIgnoreSV?: boolean;
    cpIgnoreDL?: boolean;
    cpIgnoreTP?: boolean;
    cpCountClasses?: boolean;
    cpOnlyCN?: boolean;
    cpOnlySolution?: boolean;
}

export interface ValimateRequestModelValidationStepDto {
    id?: string;
    valData?: string | undefined;
    validationSteps?: ValimateRequestValidationStepDto[] | undefined;
}

export interface ValimateRequestValidationStepDto {
    id?: string;
    valType?: string | undefined;
    valDataFileNames?: string | undefined;
    refData?: string | undefined;
    refProfiles?: string[] | undefined;
    diffDataBefore?: string | undefined;
    diffDataAfter?: string | undefined;
    tolerance?: string | undefined;
}

export interface ValimateResponseDto2 {
    body?: string | undefined;
    isSuccess?: boolean;
    statusCode?: number;
}

export interface ValimateExecutionSummaryVM {
    valimateTestCaseResult?: ValimateTestCaseResultDto[] | undefined;
    statusName?: string | undefined;
    statusShort?: string | undefined;
    sessionName?: string | undefined;
    choices?: Step2VM | undefined;
    declarationOfConformity?: DeclarationOfConformityDto | undefined;
}

export interface ExecuteSessionRequest {
    sessionId?: string;
}

export interface RerunTestCaseRequest {
    sessionId?: string;
    testCaseId?: string;
    configurationId?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}